import { IDropdownOption } from "@fluentui/react";
import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";

import { IGenericPayload } from "../../../../../../../models";
import { useAppDispatch, useAppSelector } from "../../../../../../../redux/hooks";
import { compileNameOfProperty, getGenericPayloadFromEvent } from "../../../../../../../utils/formUtils";
import { FormField } from "../../../../../../common/fields/fields";
import { BooleanSelector, OrganismSelector } from "../../../../../../request/common/selectors";
import { MasterTerminalFormStyle } from "./formStyle.jss";

import { DefaultValues } from "../../../../../../../common/enum/DefaultValues";
import { IMasterProfile } from "../../../../../../../models/resources/master/IProfile";
import { updateMasterProfileProperty } from "../../../../../../../redux/reducers/resources/master/profile/form";

export const MasterProfileForm = () => {
    const theme = useTheme();
    const style = MasterTerminalFormStyle({ theme });
    const dispatch = useAppDispatch();

    const { t } = useTranslation("common", { keyPrefix: "MASTERS" });

    const { form } = useAppSelector((state) => state.masterProfileForm);
    const { register, control } = useForm<IMasterProfile>({ mode: "onChange" });

    const onUpdateFormProperty = (name: string, value: any) => {
        const payload: IGenericPayload = {
            name,
            value,
        };

        dispatch(updateMasterProfileProperty(payload));
    };

    const handleChange = (option: IDropdownOption, name: string) => {
        const payload: IGenericPayload = {
            name,
            value: option.key,
        };
        dispatch(updateMasterProfileProperty(payload));
    };

    const onInputChange = useCallback(
        (event: any) => {
            const { name, value } = getGenericPayloadFromEvent(event);
            onUpdateFormProperty(name, value);
        },
        [dispatch],
    );
    const onYesNoOptionsChange = (option: IDropdownOption, propertyName: string) => {
        onUpdateFormProperty(propertyName, !!+option.key);
    };

    return (
        <div className={style.form}>
            <div className={style.rowForm}>
                <FormField
                    type="text"
                    label={t("CODE")}
                    value={form.code ?? DefaultValues.NOT_TEXT}
                    {...register(compileNameOfProperty<IMasterProfile>("code"), {
                        onChange: onInputChange,
                        value: form.code ?? DefaultValues.NOT_TEXT,
                    })}
                    isRequired={true}
                />

                <FormField
                    type="text"
                    label={t("DESCRIPTION")}
                    value={form.description ?? DefaultValues.NOT_TEXT}
                    {...register(compileNameOfProperty<IMasterProfile>("description"), {
                        onChange: onInputChange,
                        value: form.description ?? DefaultValues.NOT_TEXT,
                    })}
                    isRequired={true}
                />
            </div>

            <div className={style.rowForm}>
                <OrganismSelector
                    onChange={handleChange}
                    selectedKey={form.organismId ?? 0}
                    propertyName={compileNameOfProperty<IMasterProfile>("organismId")}
                    title={t("ORGANISM")}
                    isRequired={true}
                    control={control}
                />
 
                <BooleanSelector
                    onChange={onYesNoOptionsChange}
                    selectedKey={+form.active}
                    propertyName={compileNameOfProperty<IMasterProfile>("active")}
                    title={t("ACTIVE")}
                    control={control}
                    isRequired={true}
                />
            </div>
        </div>
    );
};
